// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/UnitOfMeasure.yaml
// Generated: 2026-01-22T15:19:15.465Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateUnitOfMeasure, UpdateUnitOfMeasure, UnitOfMeasure } from '@/types/core/UnitOfMeasure';

/**
 * UnitOfMeasure Service
 * CRUD operations for UnitOfMeasure via the ABP API.
 */
export const unitOfMeasureService = new EntityService<UnitOfMeasure, CreateUnitOfMeasure, UpdateUnitOfMeasure>(
  '/api/core/unitofmeasure',
  'UnitOfMeasure',
);
